/** Mirror of src/lib/sync-jobs.ts grouping for the sync status panel. */

export type SyncJobKind =
  | "daily-activity-ca"
  | "daily-activity-us"
  | "period-live-ca"
  | "period-live-us"
  | "period-settled-ca"
  | "period-settled-us";

export type SyncRegion = "ca" | "us";

export type SyncJobGroupId = "daily-activity" | "period-live" | "period-settled";

export interface SyncJobGroupDef {
  id: SyncJobGroupId;
  title: string;
  description: string;
  regions: Array<{ region: SyncRegion; label: string; kind: SyncJobKind }>;
}

export const SYNC_JOB_GROUPS: SyncJobGroupDef[] = [
  {
    id: "daily-activity",
    title: "Daily activity",
    description: "Calls, meetings, HubSpot totals",
    regions: [
      { region: "ca", label: "CA", kind: "daily-activity-ca" },
      { region: "us", label: "US", kind: "daily-activity-us" },
    ],
  },
  {
    id: "period-live",
    title: "Period (live)",
    description: "WTD, last week, month-to-date",
    regions: [
      { region: "ca", label: "CA", kind: "period-live-ca" },
      { region: "us", label: "US", kind: "period-live-us" },
    ],
  },
  {
    id: "period-settled",
    title: "Period (settled)",
    description: "Closed quarter months for QTD",
    regions: [
      { region: "ca", label: "CA", kind: "period-settled-ca" },
      { region: "us", label: "US", kind: "period-settled-us" },
    ],
  },
];

export const ALL_SYNC_JOB_KINDS: SyncJobKind[] = SYNC_JOB_GROUPS.flatMap((g) =>
  g.regions.map((r) => r.kind),
);

export const SYNC_SCHEDULE_TIMEZONE = "America/Toronto";
